var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.018 11.2036H13.7619C10.0956 11.2036 7.12354 14.1757 7.12354 17.842V53.2468C7.12354 56.9131 10.0956 59.8852 13.7619 59.8852H58.018C61.6842 59.8852 64.6564 56.9131 64.6564 53.2468V17.842C64.6564 14.1757 61.6842 11.2036 58.018 11.2036Z",
    stroke: "#727272",
    strokeWidth: 4.4256,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9547 28.9059C49.3988 28.9059 51.3803 26.9245 51.3803 24.4803C51.3803 22.0361 49.3988 20.0547 46.9547 20.0547C44.5105 20.0547 42.5291 22.0361 42.5291 24.4803C42.5291 26.9245 44.5105 28.9059 46.9547 28.9059Z",
    stroke: "#727272",
    strokeWidth: 4.4256,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5283 46.5792L29.9901 34.0644C29.1922 33.2668 28.1198 32.8039 26.9921 32.7705C25.8644 32.7371 24.7665 33.1356 23.9228 33.8846L7.12354 48.8211M31.4643 59.8851L48.5223 42.8271C49.3024 42.0455 50.3465 41.5837 51.4497 41.5325C52.5528 41.4813 53.6353 41.8444 54.4844 42.5505L64.6564 51.0339",
    stroke: "#727272",
    strokeWidth: 4.4256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.b7ecc0b4b5be70a04fbc751d4164658a.svg";
export { ForwardRef as ReactComponent };